module.exports = function (isCompetitionNew) {
    return {
        event: 'BWSAUcompetitionStart',
        eventContext: {
            competitionNew: isCompetitionNew
        }
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/competitions/atmmapper/competition-start.js
 **/